let scrollLeftBtn = document.getElementsByClassName('related-content-carousel__control--previous');
let scrollRightBtn = document.getElementsByClassName('related-content-carousel__control--next');

// Hide buttons if cards fit in screen
let offPageCarousels =  document.getElementsByClassName('related-content-carousel__cards');
for (let i = 0; i < offPageCarousels.length; i++) {
    let cards = offPageCarousels[i].childElementCount;
    if (offPageCarousels[i].offsetWidth >= (cards * 326 + (cards - 1) * 24)) {
        let index = offPageCarousels[i].getAttribute('data-index');
        document.getElementById('related-content-carousel-controls-' + index).classList.add('related-content-carousel__controls--hidden');
    }
}

for (let i = 0; i < scrollRightBtn.length; i++) {

    scrollRightBtn[i].addEventListener('click', function() {
        // Check button attribute to select the respective carousel (in case multiple in page).
        let offPageCarousel = document.getElementById('related-content-carousel-' + this.getAttribute('data-index'));
        offPageCarousel.scrollLeft += 350; // Scroll table right 350px

        // Enable the scroll left button.
        this.previousElementSibling.removeAttribute('disabled');

        let cardsCount = offPageCarousel.querySelectorAll('.tile').length;
        // Disable the scroll right button when we reach the end of the cards.
        if (Math.round( offPageCarousel.scrollLeft ) === Math.round( ( cardsCount * 326 ) + ( cardsCount - 1 ) * 24 - offPageCarousel.offsetWidth + 4) ) { // 4px left carousel padding
            this.setAttribute('disabled', true);
        }
    });

    scrollLeftBtn[i].addEventListener('click', function() {
        // Check button attribute to select the respective carousel (in case multiple in page).
        let offPageCarousel = document.getElementById('related-content-carousel-' + this.getAttribute('data-index'));
        offPageCarousel.scrollLeft -= 350; // Scroll offPageCarousel left 350px;

        // Enable the scroll right button.
        this.nextElementSibling.removeAttribute('disabled');

        // Start of table reached, disable left scrolling.
        if (offPageCarousel.scrollLeft === 0) {
            this.setAttribute('disabled', true);
        }
    });

}
